export const filingNameSelector = ({ registrations = {} } = {}, filingType) =>
  registrations.detail?.filingTypes?.model?.options?.filingTypes?.find?.(
    type => type.id === filingType
  )?.name || 'Filing Type';
